import { log } from '../log';
import {
  AdMetricsStorage,
  MetricsStorage,
  SharedMetricsStorage,
  VideoMetricsStorage
} from './types';

export const setCookie = (name: string, value: string, days: number) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

export const getCookie = (name: string) => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let c of ca) {
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const metricsLog = (msg: string, ...args: any) => log(`[Pixels.AI]:`, msg, ...args);

export const sharedMetrics: Partial<SharedMetricsStorage> = {
  start_impression: {
    value: null
  },
  completed: {
    value: null
  },
  skipped: {
    value: null
  },
  running_order_position: {
    value: null
  },
  time_watched: {
    value: null
  },
  duration: {
    value: 0
  },
  video_id: {
    value: ''
  },
  video_session: {
    value: ''
  },
  type: {
    value: null
  },
  added_by_pixels: {
    value: null
  },
  integration_type: {
    value: null
  },
  session_id: {
    value: null
  },
  design_variant: {
    value: null
  },
  cluster_index: {
    value: null
  }
};

export const videoOnlyMetrics: Partial<VideoMetricsStorage> = {
  // video only
  campaign_id: {
    value: null
  },
  contextual: {
    value: false
  }
};

export const adOnlyMetrics: Partial<AdMetricsStorage> = {
  ad_request: {
    value: null
  },
  ad_error: {
    value: null
  },
  ad_click: {
    value: null
  },
  ad_pos: {
    value: null
  },
  ad_cpm: {
    value: null
  },
};

export const getDefaultData = () => {
  return {
    ...adOnlyMetrics,
    ...sharedMetrics,
    ...videoOnlyMetrics,
  };
};

export const getData = (key: string) => {
  const dataFromStorage = localStorage.getItem(key);
  const defaultData = getDefaultData();
  try {
    return {
      ...defaultData,
      ...JSON.parse(dataFromStorage)
    };
  } catch (e) {
    console.error(`Unable to parse data storage`);
    return defaultData;
  }
};

export const setData = (key: string, data: any) => localStorage.setItem(key, JSON.stringify(data));

export const toUnixTimestamp = (ms: number) => Math.floor(ms / 1000);

type SEGMENT_ITEM = {
  description: string;
  min: number;
  max: number
};

export type SEGMENT = Record<string, SEGMENT_ITEM>;

export const findSegmentByNumericValue = (segments: SEGMENT, x: number) => {
  return Object.entries(segments).find(([, { min, max }]) => x >= min && x <= max);
};
